import {SignalREvent, SignalRHub} from 'constants/dataEnum';
import {invokeAPI} from 'stores/business/commonBusiness';
import GlobalReduxStore from 'stores/globalReduxStore';

export const checkIsPlateRecognitionEnabled = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_PLATE_RECOGNITION_ENABLED));
  } catch (error) {
    console.error('error in checkIsHumidifierConnected', error);
  }
  return response;
};

export const checkIsAlreadyScannedEmptyNests = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_ALREADY_SCANNED_ALL_EMPTY_NESTS));
  } catch (error) {
    console.error('error in checkIsHumidifierConnected', error);
  }
  return response;
};

export const registerPlateLibAllEmptyNests = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.REGISTER_PLATE_LIB_EMPTY_NESTS));
  } catch (error) {
    console.error('error in startPlateRecognition', error);
  }
  return response;
};

export const setPlateRecognitionEnabled = async (isEnabled) => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SET_PLATE_RECOGNITION_ENABLED, isEnabled));
  } catch (error) {
    console.error('error in setPlateRecognitionEnabled', error);
  }
  return response;
};

export const getCurrentScannedNestIds = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_CURRENT_SCANNED_NEST_IDS));
  } catch (error) {
    console.error('error in getCurrentScannedNestIds', error);
  }
  return response;
};

export const clearAllCurrentScannedNestsData = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.CLEAR_ALL_CURRENT_SCANNED_NESTS_DATA));
  } catch (error) {
    console.error('error in clearAllCurrentScannedNestsData', error);
  }
  return response;
};

export const scanSingleNestAndCacheData = async (nestId) => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SCAN_SINGLE_NEST_AND_CACHE_DATA, nestId));
  } catch (error) {
    console.error('error in scanSingleNestAndCacheData', error);
  }
  return response;
};

export const registerCachedDetectionData = async (plateId) => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.REGISTER_CACHED_DETECTION_DATA, plateId));
  } catch (error) {
    console.error('error in registerCachedDetectionData', error);
  }
  return response;
};

export const getIsPlateAlreadyTrained = async (plateId) => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_PLATE_ALREADY_TRAINED, plateId));
  } catch (error) {
    console.error('error in getIsPlateAlreadyTrained', error);
  }
  return response;
};

export const SetFeedbackForRuntimePlateValidationApi = async (falseDetectionNestIds, reScanNestsIds) => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(
      invokeAPI(
        SignalRHub.INSTRUMENT,
        SignalREvent.SET_FEEDBACK_FOR_RUNTIME_PLATE_VALIDATION,
        falseDetectionNestIds,
        reScanNestsIds,
      ),
    );
  } catch (error) {
    console.error('error in SetFeedbackForRuntimePlateValidationApi', error);
  }
  return response;
};

export const getPlatesTrainingStatusApi = async (plateIds) => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_PLATE_TRAINING_STATUS, plateIds));
  } catch (error) {
    console.error('error in GetPlatesTrainingStatusApi', error);
  }
  return response;
};

export const removePlateFromLibraryApi = async (plateIds) => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.REMOVE_PLATE_FROM_LIBRARY, plateIds));
  } catch (error) {
    console.error('error in removePlateFromLibraryApi', error);
  }
  return response;
};
